<template>
  <div class="cashflow-app-tour">
    <previous-cashflow-view v-if="isPreTour"/>
    <cashflow-tour v-else-if="isDuringTour"/>
    <previous-cashflow-view v-else-if="isPostTour"/>
    <div v-else class="message-container">
      <img class="icon" :src="require('@/assets/icons/hands_raised.png')">
      <div class="paragraph">
        <div class="title">אנחנו מכינים את התזרים של חודש {{ nextMonthName }}!</div>
        <div class="text">
          <span>הבוט של riseup   🤖 יעדכן אותך בWhatsApp כשהוא מוכן!</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Segment from '../../../../Segment';
import PreviousCashflowView from './cashflow-view-tour/PreviousCashflowView.vue';
import CashflowTour from './cashflow-view-tour/CashflowTour.vue';
import cashflowHistory from '../../../../store/utilities/cashflow-history';

export default {
  name: 'CashflowAppTour',
  components: {
    PreviousCashflowView,
    CashflowTour,
  },
  created() {
    Segment.trackUserGot('CashflowAppTourEntered', { cashflowApp: true });
    Segment.trackUserGotToPixel('CATE');
  },
  computed: {
    ...mapState('cashflowTour', ['tourState']),
    ...mapState('cashflowView', ['currentBudgetDate']),
    ...mapGetters('session', ['householdName']),
    ...mapGetters('cashflowTour', ['isPreTour', 'isDuringTour', 'isPostTour']),
    nextMonthName() {
      return cashflowHistory.getFullMonthName(this.currentBudgetDate);
    },
  },
};
</script>

<style lang="scss" scoped>
  .cashflow-app-tour {
    .message-container {
      text-align: center;
      line-height: 26px;
      font-size: 14px;
      margin-top: 110px;

      .icon {
        height: 90px;
      }

      .title {
        width: 100%;
        font-family: GretaSans;
        font-size: 24px;
        line-height: 32px;
        padding: 26px 35px 5px;
      }

      .text {
        white-space: pre-wrap;
        padding: 0px 35px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/cashflow-tour/CashflowAppTour.vue